{
  "version": 1,
  "asset_id": "9b019fb4-3f17-4a2b-833c-f396a0408cd3",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/9b019fb4-3f17-4a2b-833c-f396a0408cd3/skiff-rental.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/9b019fb4-3f17-4a2b-833c-f396a0408cd3/skiff-rental.jpg",
  "original_filename": "skiff-rental.jpg",
  "size": 567818,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:47:36Z"
}
